import { useEffect, useState } from "react";

import { X } from "lucide-react";

import swal from "../../lib/swal";
import Loading from "../../components/Loading";

const OpeningBalanceGenerateModal = ({ open, onClose, onSave }) => {
  const [loading, setLoading] = useState(false);

  const [effectiveDate, setEffectiveDate] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (!open) return;

    resetForm();
  }, [open]);

  const resetForm = () => {
    setEffectiveDate(new Date().toISOString().slice(0, 10));
    setNotes("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    if (!effectiveDate) {
      return swal.fire({
        icon: "warning",
        title: "Data Belum Lengkap",
        text: "Tanggal efektif wajib diisi.",
      });
    }

    try {
      setLoading(true);

      await onSave({
        effective_date: effectiveDate,
        notes: notes.trim() || null,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex max-h-[90vh] w-full max-w-lg flex-col overflow-hidden rounded-xl border border-border bg-card shadow-modal"
      >
        {/* Header */}

        <div className="flex items-center justify-between border-b border-border px-5 py-4">
          <div>
            <h2 className="text-lg font-bold text-secondary">
              Generate Opening Balance
            </h2>

            <p className="text-sm text-muted">
              Generate opening balance berdasarkan saldo transaksi.
            </p>
          </div>

          <button
            onClick={onClose}
            className="rounded-full p-2 text-secondary transition hover:bg-primary hover:text-white"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}

        <form
          onSubmit={handleSubmit}
          className="flex flex-1 flex-col overflow-hidden"
        >
          <div className="flex-1 space-y-5 overflow-y-auto p-5">
            <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-4">
              <p className="text-sm text-yellow-800">
                Generate Opening Balance akan membuat checkpoint saldo seluruh
                account berdasarkan transaksi sampai tanggal efektif yang
                dipilih.
              </p>
            </div>

            {/* Effective Date */}

            <div>
              <label className="mb-2 block text-sm font-medium text-text">
                Tanggal Efektif
              </label>

              <input
                type="date"
                value={effectiveDate}
                onChange={(e) => setEffectiveDate(e.target.value)}
                className="w-full rounded-lg border border-border bg-surface px-4 py-3 text-text outline-none transition focus:border-primary"
              />
            </div>

            {/* Notes */}

            <div>
              <label className="mb-2 block text-sm font-medium text-text">
                Catatan
              </label>

              <textarea
                rows={4}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Masukkan catatan checkpoint (opsional)"
                className="w-full resize-none rounded-lg border border-border bg-surface px-4 py-3 text-text outline-none transition focus:border-primary"
              />
            </div>
          </div>

          {/* Footer */}

          <div className="flex justify-end gap-3 border-t border-border px-5 py-4">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="rounded-lg border border-border bg-surface px-5 py-2 font-medium text-text transition hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-70"
            >
              Batal
            </button>

            <button
              type="submit"
              disabled={loading}
              className="flex min-w-[170px] items-center justify-center rounded-lg bg-secondary px-5 py-2 font-semibold text-white transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {loading ? <Loading.Button text="Generating..." /> : "Generate"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OpeningBalanceGenerateModal;
